class Translator {
    constructor() {
        this.siteLang = document.documentElement.getAttribute('lang');
        // fallback implementation to avoid crashes, in case i18n() is used
        // before the catalog has loaded
        this.catalog = (msgid) => msgid;
        this.catalogName = 'translate-catalog!tud.theme.webcms2.jarn';

        // require mockup-i18n, load language catalog and use it for building the message
        window.require([this.catalogName], (theme) => {
            this.catalog = theme;
        });
    }

    get i18n() {
        return this.catalog;
    }

    get lang() {
        return this.siteLang;
    }

    /**
     * Returns a promise once we have loaded the module.
     * Note: Unfortunately it is not guaranteed, that the catalog is present.
     */
    get ready() {
        return new Promise((resolve) => {
            window.require([this.catalogName], () => {
                resolve();
            });
        });
    }
}

const translator = new Translator();
export default translator;
